import { styled } from "@mui/material";
import { colorPickerName } from "../../../../../../../classes.js";
const GreedyColumn = styled("div", {
  name: colorPickerName,
  slot: "GreedyColumn"
})(() => ({
  position: "relative",
  overflow: "hidden",
  maxWidth: "100%"
}));
export {
  GreedyColumn
};
//# sourceMappingURL=GreedyColumn.js.map
